module.exports = __webpack_public_path__ + "static/media/percentage-light.44aa027e.svg";